import { render } from "./OldChildActivities.vue?vue&type=template&id=015afb1b&scoped=true"
import script from "./OldChildActivities.vue?vue&type=script&lang=js"
export * from "./OldChildActivities.vue?vue&type=script&lang=js"

import "./OldChildActivities.vue?vue&type=style&index=0&id=015afb1b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-015afb1b"]])

export default __exports__